import type { DataLevel } from '../lib/securityFilter'

interface SecurityBadgeProps {
  level: DataLevel
  confidential?: boolean
}

const badgeStyle: Record<DataLevel, React.CSSProperties> = {
  L1: { background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0' },
  L2: { background: '#E6F1FB', color: '#0C447C', border: '1px solid #85B7EB' },
  L3: { background: '#FAEEDA', color: '#633806', border: '1px solid #EF9F27' },
  L4: { background: '#FCEBEB', color: '#791F1F', border: '1px solid #F09595' },
}

export function SecurityBadge({ level, confidential }: SecurityBadgeProps) {
  return (
    <span
      style={{
        ...badgeStyle[level],
        borderRadius: 4,
        padding: '1px 6px',
        fontSize: 11,
        fontWeight: 600,
        flexShrink: 0,
      }}
    >
      {confidential ? `${level} Confidential` : level}
    </span>
  )
}
